import * as React from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { Link } from 'react-router';
import balanceStatuses from '../../../const/billingStatuses';
import billingStatusHelper from '../../../services/mini/billingStatusHelper';
import { routeInfo } from '../../../routeInfo';

function BalanceBanner({ billingStatus, memberOf }: BalanceBannerReduxProps) {
    const { message } = billingStatusHelper(billingStatus, memberOf);
    const isOrganizationMember = !!memberOf;
    const isWarning = billingStatus === balanceStatuses.RUNNING_LOW ||
        billingStatus === balanceStatuses.LIMITED;

    if (billingStatus === balanceStatuses.RUNNING_LOW ||
        billingStatus === balanceStatuses.LIMITED ||
        billingStatus === balanceStatuses.BLOCKED
    ) {
        return <div className={`balance-banner ${isWarning ? 'warning' : ''}`}>
            {message} {!isOrganizationMember && <Link to={routeInfo.billing.path}>View billing</Link>}
        </div>;
    }

    return <></>;
}

function mapStateToProps({ user }, ownProps) {
    return {
        billingStatus: user.billingStatus,
        memberOf: user.memberOf
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}

const connector = connect(mapStateToProps, mapDispatchToProps);

type BalanceBannerReduxProps = ConnectedProps<typeof connector>;

export default connector(BalanceBanner);
